import { handleActions } from 'redux-actions';
import { props } from 'ramda';

import { updateToken } from 'api';
import i18n from 'locale';

import { AUTHENTICATE, LOGOUT, UPDATE_USER } from './types';
import { AUTH, LOGGED_IN, USER, TOKEN, STATUS, ID, LANGUAGE } from '.';

const storage = window[process.env.REACT_APP_TOKEN_STORAGE];

const getInit = () => ({
  [AUTH]: Boolean(storage[TOKEN]),
  [LOGGED_IN]: false,
  [USER]: {},
});

export default handleActions(
  {
    [AUTHENTICATE]: (state, { payload }) => {
      const [token, status, id] = props([TOKEN, STATUS, ID], payload || {});

      updateToken(token);

      if (payload[LANGUAGE] && window.localStorage?.getItem('i18nextLng') !== payload[LANGUAGE]) {
        i18n.changeLanguage(payload[LANGUAGE]);
      }

      return {
        ...state,
        [AUTH]: Boolean(token),
        [LOGGED_IN]: Boolean(token && id) && status === 1,
        [USER]: payload,
      };
    },
    [LOGOUT]: () => {
      updateToken();

      return getInit();
    },
    [UPDATE_USER]: (state, { payload }) => ({
      ...state,
      [USER]: { ...state[USER], ...payload },
    }),
  },
  getInit()
);
